const NODE_ENV = process.env.NODE_ENV;

const baseConfig = {
    project: 'common', // 项目名称 【 common 云平台 】 【 sichuan 四川私有化部署 】
};

const output = {

    common: {
        // publicPath:'/app/',
        frontPath:'',
        frontPathRoot:'/',
        xauthUrl:NODE_ENV === 'production' ? 'https://xauth.shijieu.cn' : 'http://xauth.t.shijieu.cn',
        xauthApi: (NODE_ENV === 'production') ? 'https://api.xauth.shijieu.cn' : '//api.xauth.t.shijieu.cn',
        sjsyApi: NODE_ENV === 'production' ? 'https://api.shijieu.cn/' : '//api.t.shijieu.cn/',
        xblogApi:NODE_ENV === 'production' ? 'https://api.shijieu.cn' : '//api.t.shijieu.cn',
        studentOrigin:NODE_ENV === 'production' ? 'https://xs.shijieu.cn' : 'http://xs.t.shijieu.cn',
        parentsOrigin: NODE_ENV === 'production' ? 'https://jz.shijieu.cn' : 'http://jz.t.shijieu.cn',
        studentLoginUrl: (NODE_ENV === 'production' ? 'https://xauth.shijieu.cn' : 'http://xauth.t.shijieu.cn') + `/xauth/user/login?xauth_redirect=` + (NODE_ENV === 'production' ? 'https://xs.shijieu.cn' : 'http://xs.t.shijieu.cn') + '/#/student/studentlogin',
        parentsLoginUrl:(NODE_ENV === 'production' ? 'https://xauth.shijieu.cn' : 'http://xauth.t.shijieu.cn') + '/xauth/user/login?xauth_redirect=' + (NODE_ENV === 'production' ? 'https://jz.shijieu.cn' : 'http://jz.t.shijieu.cn') + '/parents' + '/#/parents/parentslogin',
        xbagUrl:NODE_ENV === 'production' ? 'http://xs.shijieu.cn/xstatic/xbag/college/' : 'http://xs.t.shijieu.cn/xstatic/xbag/college/',
        studentLoginUrlWithSchoolCode:function (){
            try {
                const userInfo = JSON.parse(window.localStorage.getItem('user_detail'));
                const schoolInfo = userInfo.student.school || {};
                return (NODE_ENV === 'production' ? 'https://xauth.shijieu.cn' : 'http://xauth.t.shijieu.cn') + `/xauth/user/login?schoolCode=${schoolInfo.code || ''}&xauth_redirect=` + (NODE_ENV === 'production' ? 'https://xs.shijieu.cn' : 'http://xs.t.shijieu.cn') + '/#/student/studentlogin';
            } catch (err) {
                return (NODE_ENV === 'production' ? 'https://xauth.shijieu.cn' : 'http://xauth.t.shijieu.cn') + `/xauth/user/login?xauth_redirect=` + (NODE_ENV === 'production' ? 'https://xs.shijieu.cn' : 'http://xs.t.shijieu.cn') + '/#/student/studentlogin';
            }
        }
    },
    sichuan: {
        // publicPath:'/sichuan/sjdx/xs/',
        frontPath:'/sichuan/sjdx/xs',
        frontPathRoot:'/sichuan/sjdx/xs',
        xauthUrl:'https://bigapp.scedu.net/sichuan/sjdx/xauth/user/login/',
        xauthApi: 'https://bigapp.scedu.net/sjdx/api',
        sjsyApi: 'https://bigapp.scedu.net/sjdx/api/',
        xblogApi:'https://api.shijieu.cn',
        studentOrigin:'https://bigapp.scedu.net/sichuan/sjdx/xs/',
        parentsOrigin: 'https://bigapp.scedu.net/sichuan/sjdx/jz/',
        studentLoginUrl:'https://bigapp.scedu.net/sichuan/sjdx/xauth/user/login/?xauth_redirect=https://bigapp.scedu.net/sichuan/sjdx/xs/#/student/studentlogin',
        parentsLoginUrl:'https://bigapp.scedu.net/sichuan/sjdx/xauth/user/login/?xauth_redirect=https://bigapp.scedu.net/sichuan/sjdx/jz/#/parents/parentslogin',
        xbagUrl:'https://bigapp.scedu.net/sichuan/sjdx/xstatic/xbag/college/',
        studentLoginUrlWithSchoolCode:function (){
            try {
                const userInfo = JSON.parse(window.localStorage.getItem('user_detail'));
                const schoolInfo = userInfo.student.school || {};
                return `https://bigapp.scedu.net/sichuan/sjdx/xauth/user/login/?schoolCode=${schoolInfo.code || ''}&xauth_redirect=https://bigapp.scedu.net/sichuan/sjdx/xs/#/student/studentlogin`;
            } catch (err) {
                return 'https://bigapp.scedu.net/sichuan/sjdx/xauth/user/login/?xauth_redirect=https://bigapp.scedu.net/sichuan/sjdx/xs/#/student/studentlogin';
            }
        }
    },
}[baseConfig.project];

module.exports = {
    baseConfig,
    output,
}



// WEBPACK FOOTER //
// ./src/constant/configPrivatization.js